module.exports = __webpack_public_path__ + "img/Slide10.db6b8999.png";